module.exports = __webpack_public_path__ + "img/busine-3.dc57bed5.png";